import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const CTA = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-20 bg-gradient-to-b from-darkerBlue to-darkBlue">
      <div className="container max-w-4xl mx-auto px-6 text-center">
        <motion.h2 
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.7 }}
          className="text-3xl md:text-5xl font-bold mb-8 highlight"
        >
          Siap Meningkatkan Level Trading Anda?
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: 0.3, duration: 0.7 }}
          className="text-xl mb-12 max-w-3xl mx-auto"
        >
          Bergabunglah dengan ratusan trader yang telah sukses memanfaatkan momentum berita ekonomi untuk menghasilkan profit konsisten dengan teknik News Hack
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: 0.6, duration: 0.7 }}
          className="flex flex-col items-center mb-12"
        >
          <p className="mb-3">Pembelajaran via</p>
          <div className="bg-white text-blue-600 font-bold text-2xl px-8 py-3 rounded-lg">
            ZOOM
          </div>
        </motion.div>
        
        <motion.a 
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          whileHover={{ scale: 1.05, boxShadow: "0 15px 30px rgba(194, 42, 42, 0.4)" }}
          whileTap={{ scale: 0.95 }}
          href="/checkout" 
          className="btn-primary text-white font-bold py-4 px-10 rounded-lg text-xl uppercase inline-block mb-6"
        >
          Daftar Sekarang
        </motion.a>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ delay: 1.2, duration: 0.7 }}
          className="mb-12"
        >
          <p className="text-lg text-primary">
            Atau klik tombol di atas untuk langsung checkout
          </p>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 0.6 } : { opacity: 0 }}
          transition={{ delay: 1.5, duration: 0.7 }}
          className="text-sm opacity-60"
        >
          <p>© 2025 News Hack. All Rights Reserved.</p>
          <p>Hasil trading dapat bervariasi tergantung kondisi pasar dan kemampuan individual.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;